import { render, staticRenderFns } from "./PasswordRemindCheckCode.vue?vue&type=template&id=2ee68c36&scoped=true&"
import script from "./PasswordRemindCheckCode.vue?vue&type=script&lang=ts&"
export * from "./PasswordRemindCheckCode.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordRemindCheckCode.vue?vue&type=style&index=0&id=2ee68c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee68c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VForm,VImg,VRow})
